import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PaymentOrderImportDTO  {
    _originalTypeClassName = "zERP.BO.PaymentOrderImportDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PaymentOrderImportDTO.translate = translateService;
}
this.Year = null;
this.Series = null;
this.SeriesNumber = null;
this.IssueDate = null;
this.PaymentDate = null;
this.TransactionEntityVAT = null;
this.TransactionEntityName = null;
this.PaymentOrderAmount = null;
this.Notes = null;
this.PaymentMethod = null;
this.Issuer = null;
this.Payer = null;
this.InvoiceDate = null;
this.InvoiceType = null;
this.InvoiceNumber = null;
this.InvoiceTransactionEntityVAT = null;
this.InvoiceAmount = null;
this.InvoiceVATAmount = null;
this.PayableAmount = null;
this.CheckAmount = null;
this.CheckIssueDate = null;
this.CheckTransferToSupplierDate = null;
this.CheckExtraitDate = null;
this.CheckTransactionEntityName = null;
this.CashAccount = null;
this.IBAN = null;
this.CheckBlockCreatedDate = null;
this.CheckNumber = null;
this.PaymentOrderImportDTOKey = null;
this._key = this.PaymentOrderImportDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Year:any;
Series:any;
SeriesNumber:any;
IssueDate:any;
PaymentDate:any;
TransactionEntityVAT:any;
TransactionEntityName:any;
PaymentOrderAmount:any;
Notes:any;
PaymentMethod:any;
Issuer:any;
Payer:any;
InvoiceDate:any;
InvoiceType:any;
InvoiceNumber:any;
InvoiceTransactionEntityVAT:any;
InvoiceAmount:any;
InvoiceVATAmount:any;
PayableAmount:any;
CheckAmount:any;
CheckIssueDate:any;
CheckTransferToSupplierDate:any;
CheckExtraitDate:any;
CheckTransactionEntityName:any;
CashAccount:any;
IBAN:any;
CheckBlockCreatedDate:any;
CheckNumber:any;
private _PaymentOrderImportDTOKey:any;
get PaymentOrderImportDTOKey(): any {
    return this._PaymentOrderImportDTOKey;
  }
set PaymentOrderImportDTOKey(value: any) {
    this._PaymentOrderImportDTOKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.PaymentOrderImportDTOKey == null || $this.PaymentOrderImportDTOKey == 0;
            }


}